var map = {
	"./rir-logo-dark-collapsed.svg": [
		"628a",
		"chunk-2d0cefdb"
	],
	"./rir-logo-dark.svg": [
		"aff4",
		"chunk-2d214469"
	],
	"./rir-logo-default-collapsed.svg": [
		"2635",
		"chunk-2d0b2c9c"
	],
	"./rir-logo-default.svg": [
		"3b95",
		"chunk-2d0c46e1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b17a";
module.exports = webpackAsyncContext;